/* Gerido pelo BukProd — reaplicado após cada atualização do tema.
   Pré-selecciona o filtro "Em stock" nas coleções. */
(function () {
  "use strict";

  // Não mexer para crawlers: queremos que o Google indexe a coleção completa,
  // não a versão filtrada.
  var ua = navigator.userAgent || "";
  if (/bot|crawl|spider|slurp|bingpreview|lighthouse|headless/i.test(ua)) return;

  if (location.pathname.indexOf("/collections/") !== 0) return;

  // A coleção é desenhada pela pesquisa (ms-search.js), que já abre com o
  // «Em stock» ligado sem recarregar a página. O recarregamento daqui era o
  // que mostrava a grelha antiga antes da nova (17/10/2026).
  if (document.documentElement.classList.contains("msc-col-espera")) return;

  var qs = location.search || "";

  // Já há uma escolha do utilizador em curso — não interferir.
  if (qs.indexOf("filter.") !== -1) return;
  if (qs.indexOf("sort_by") !== -1) return;
  if (qs.indexOf("page=") !== -1) return;

  // Se o utilizador desligar o filtro, não o voltamos a impor nesta coleção
  // durante a sessão. Sem isto era impossível ver os esgotados.
  var key = "bukprod:stock:" + location.pathname;
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
  } catch (e) {
    // sessionStorage bloqueado (modo privado): melhor não redirecionar de todo,
    // senão entramos em ciclo.
    return;
  }

  var sep = qs ? "&" : "?";
  location.replace(location.pathname + qs + sep + "filter.v.availability=1");
})();

/* ---------------------------------------------------------------------------
   Texto de entrega nos cartões de produto.

   O tema escreve «Enviamos em 24 horas» ao lado do stock (é o
   deliverytime_in_stock do snippets/product-deliverytime.liquid). É texto fixo:
   diz o mesmo às 10h de terça e às 23h de domingo — e no segundo caso é uma
   promessa que o armazém não cumpre.

   Passa a anunciar o dia da entrega em vez do envio: «Receba amanhã» quando é
   mesmo amanhã, «Receba na quarta» quando não é. Uma compra às 18h de segunda
   já não apanha a expedição de hoje, sai na terça e chega na quarta; à sexta,
   seja a que horas for, a entrega é na segunda.

   A previsão vale para Portugal continental, que é para onde vai a esmagadora
   maioria das encomendas. Para as ilhas o prazo é maior e o texto fica optimista:
   é assumido de propósito, não é um caso por tratar.

   Porquê aqui e não em Liquid: a decisão depende da hora, e o Liquid é
   renderizado uma vez e servido de cache. Uma página gerada às 15h continuaria
   a prometer «Receba amanhã» às 22h. No browser a hora é sempre a de agora.

   A hora é a de Lisboa e não a do visitante: quem decide se a encomenda sai
   hoje é o armazém, não quem está a comprar de outro fuso.
--------------------------------------------------------------------------- */
(function () {
  "use strict";

  // Expedimos no próprio dia o que entra até às 16h30, e a entrega chega no dia
  // útil seguinte.
  var CORTE_HORA = 16;
  var CORTE_MINUTO = 30;

  var TEXTO_ORIGINAL = "Enviamos em 24 horas";

  // A voz é a mesma que o tema usa no contador da ficha do produto
  // ("Receba já amanhã!"). Duas maneiras de dizer a mesma promessa na mesma
  // página fazem a loja parecer dois sítios.
  //
  // E os dias levam o "-feira": em português escreve-se segunda-feira, não
  // segunda. Sábado e domingo não levam.
  var TEXTO_AMANHA = "Receba já amanhã!";
  var PREFIXO_DIA = "Receba já na ";
  var SUFIXO_DIA = "!";
  var DIAS_NOME = ["domingo", "segunda-feira", "terça-feira", "quarta-feira",
                   "quinta-feira", "sexta-feira", "sábado"];

  // A true, o dia seguinte diz «Receba amanhã» em vez de «Receba na terça».
  var USAR_AMANHA = true;

  // Rede de segurança: se a entrega cair a mais de uma semana — uma ponte de
  // feriados longa — o nome do dia deixa de identificar a data sem ambiguidade,
  // e mais vale não arriscar.
  var TEXTO_SEM_PREVISAO = "Envio em 24h";
  var LIMITE_NOME_DIA = 6;
  var LIMITE_PROCURA = 14;

  // Feriados sem expedição nem entrega, em ISO (aaaa-mm-dd). Vazio = só conta o
  // fim de semana. Ficam à mão de propósito: os móveis (Sexta-Feira Santa, Páscoa,
  // Corpo de Deus) mudam de data todos os anos.
  var FERIADOS = [];

  // Só mexemos no texto de fábrica e no nosso. O deliverytime_in_stock pode vir
  // de um metafield por produto, e aí o texto foi escolhido para aquele artigo —
  // reescrevê-lo era apagar informação verdadeira. A lista tem de incluir tudo o
  // que nós próprios escrevemos, senão a revisão periódica não reconhecia o
  // texto que já lá está e a previsão ficava congelada.
  var CONHECIDOS = [TEXTO_ORIGINAL, TEXTO_AMANHA, TEXTO_SEM_PREVISAO];
  for (var d = 0; d < DIAS_NOME.length; d++) {
    CONHECIDOS.push(PREFIXO_DIA + DIAS_NOME[d] + SUFIXO_DIA);
  }

  // Textos que este ficheiro já escreveu antes de a loja mudar de voz. Sem
  // eles, a revisão periódica deixava de reconhecer o que ele próprio tinha
  // posto, e uma página aberta desde ontem ficava com a promessa congelada.
  var DIAS_ANTIGOS = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"];
  CONHECIDOS.push("Receba amanhã");
  for (var v = 0; v < DIAS_ANTIGOS.length; v++) CONHECIDOS.push("Receba na " + DIAS_ANTIGOS[v]);

  function emLisboa(quando) {
    // O Intl devolve os campos já convertidos: evita contas com offsets e trata
    // sozinho da mudança para a hora de verão.
    var partes = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/Lisbon",
      weekday: "short",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23"
    }).formatToParts(quando);

    var p = {};
    for (var i = 0; i < partes.length; i++) p[partes[i].type] = partes[i].value;

    var dias = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return {
      dia: dias[p.weekday],
      minutos: parseInt(p.hour, 10) * 60 + parseInt(p.minute, 10),
      data: p.year + "-" + p.month + "-" + p.day
    };
  }

  function diaUtil(t) {
    if (t.dia === 0 || t.dia === 6) return false;
    return FERIADOS.indexOf(t.data) === -1;
  }

  function diaRelativo(base, n) {
    return emLisboa(new Date(base.getTime() + n * 86400000));
  }

  function diasAteEntrega(hoje) {
    // Contamos a partir do meio-dia UTC da data de hoje em Lisboa. Somar dias à
    // hora a que estamos partia-se nos dois dias do ano em que o relógio muda:
    // num deles o dia local tem 25 horas, e +24h cai na mesma data.
    var base = new Date(hoje.data + "T12:00:00Z");

    // Expedição: hoje, se ainda é dia útil e a encomenda apanha o corte. Senão,
    // o próximo dia útil.
    var expedicao = 0;
    if (!diaUtil(hoje) || hoje.minutos >= CORTE_HORA * 60 + CORTE_MINUTO) {
      expedicao = 1;
      while (expedicao <= LIMITE_PROCURA && !diaUtil(diaRelativo(base, expedicao))) expedicao++;
    }

    // Entrega: o dia útil a seguir ao da expedição.
    var entrega = expedicao + 1;
    while (entrega <= LIMITE_PROCURA && !diaUtil(diaRelativo(base, entrega))) entrega++;

    if (entrega > LIMITE_NOME_DIA) return null;
    return { dias: entrega, dia: diaRelativo(base, entrega).dia };
  }

  function textoDaEntrega(hoje) {
    var e = diasAteEntrega(hoje);
    if (!e) return TEXTO_SEM_PREVISAO;
    if (e.dias === 1 && USAR_AMANHA) return TEXTO_AMANHA;
    return PREFIXO_DIA + DIAS_NOME[e.dia] + SUFIXO_DIA;
  }

  /* A promessa de entrega, para quem a queira fora dos cartões do tema.
   *
   * Quem a quer é a camada de pesquisa, que desenha cartões próprios e tem de
   * dizer exactamente o mesmo que a loja diz nos dela. A alternativa era copiar
   * para lá o corte das 16:30, os feriados e a contagem dos dias úteis — e no
   * dia em que uma dessas regras mudasse, ficavam duas lojas a prometer coisas
   * diferentes na mesma página.
   *
   * Devolve null quando não há previsão fiável. Quem chamar tem de aguentar o
   * null: este ficheiro pode não estar carregado, ou o Intl pode falhar. */
  window.BUKPROD_ENTREGA = function () {
    try {
      var hoje = emLisboa(new Date());
      if (typeof hoje.dia !== "number" || isNaN(hoje.minutos)) return null;
      return textoDaEntrega(hoje);
    } catch (e) {
      return null;
    }
  };

  /* Um aluguer nunca promete entrega.
   *
   * Um aluguer combina-se, levanta-se e devolve-se — não segue por
   * transportadora no dia seguinte. A promessa é uma só para a página inteira
   * e não sabe distinguir um cabo de um aluguer, por isso a distinção faz-se
   * aqui, elemento a elemento.
   *
   * A regra é a mesma do resto do projecto (`_product_is_rental`): a palavra
   * no título. Sobe-se até seis níveis à procura de um título ou de uma
   * ligação para a ficha — chega para apanhar o cartão na coleção e a coluna
   * de informação na ficha do produto, sem depender de nomes de classes do
   * tema, que mudam entre versões. */
  function dentroDeAluguer(no) {
    var p = no;
    for (var i = 0; i < 6 && p && p !== document.body; i++) {
      if (p.querySelector) {
        var t = p.querySelector("h1, h2, h3, a[href*='/products/']");
        if (t && /aluguer/i.test(t.textContent || "")) return true;
      }
      p = p.parentNode;
    }
    return false;
  }

  /* Na ficha de um aluguer, o contador do tema também se cala.
   *
   * Esse bloco é do Xtra e o texto dele vem das traduções, não passa por aqui
   * — estava a prometer "Receba já amanhã!" num pack de aluguer de 180 EUR.
   * Esconde-se em vez de se reescrever: a marcação é dele e tem um contador
   * lá dentro. */
  function calarContadorDeAluguer() {
    var h1 = document.querySelector("h1");
    if (!h1 || !/aluguer/i.test(h1.textContent || "")) return;
    /* `style.display` e não `hidden`: o atributo vale como estilo do
       browser, e qualquer `display` que o tema ponha ganha-lhe. Com
       `hidden = true` o contador continuava à vista numa ficha de aluguer. */
    var contadores = document.querySelectorAll(".f8pr-shipping-timer");
    for (var i = 0; i < contadores.length; i++) contadores[i].style.display = "none";
  }

  /* O contador do tema a dizer o mesmo que os cartões.
   *
   * O bloco "Receba já amanhã! Encomende dentro de: ..." é do Xtra e o texto
   * vem das traduções — é fixo, não calcula nada. Numa sexta-feira dizia
   * "amanhã" ao lado de um "Receba já na segunda-feira!" calculado por nós, e a
   * ficha ficava a discordar de si própria.
   *
   * Mexe-se só no <span class="strong">, que é onde vive a promessa. O resto da
   * linha — o "Encomende dentro de:" e o contador — é dele e fica intacto. */
  function acertarContadorDoTema(novo) {
    var blocos = document.querySelectorAll(".f8pr-shipping-timer .strong");
    for (var i = 0; i < blocos.length; i++) {
      if (blocos[i].textContent.trim() !== novo) blocos[i].textContent = novo;
    }
  }

  /* A ficha é de um aluguer? A regra é a do resto do projecto: a palavra no
     título. Aqui basta o <h1>, que na ficha é o nome do produto. */
  function fichaDeAluguer() {
    var h1 = document.querySelector("h1");
    return !!(h1 && /aluguer/i.test(h1.textContent || ""));
  }

  /* Troca o texto DENTRO dos nós de texto, e não o innerHTML.
     Os botões do tema têm ícones e <span> de estado lá dentro; reescrever o
     innerHTML apagava-os e o botão deixava de mostrar o "a processar". */
  function trocarTexto(raiz, procura, novoTexto) {
    var pilha = [raiz];
    while (pilha.length) {
      var no = pilha.pop();
      for (var i = 0; i < no.childNodes.length; i++) {
        var f = no.childNodes[i];
        if (f.nodeType === 3) {
          if (procura.test(f.nodeValue)) f.nodeValue = f.nodeValue.replace(procura, novoTexto);
        } else if (f.nodeType === 1) {
          pilha.push(f);
        }
      }
    }
  }

  /* Um aluguer não se compra já, reserva-se.
   *
   * O «Compre já!» é o botão de pagamento imediato da Shopify: salta o carrinho
   * e vai direito a pagar. Num aluguer isso é uma encomenda feita sem combinar
   * datas nem caução — exactamente a que alguém vai ter de desfazer ao
   * telefone. Esconde-se.
   *
   * O «Adicionar ao carrinho» fica, porque é por aí que os alugueres desta loja
   * passam de facto, mas passa a chamar-se «Reservar»: é o que a pessoa está
   * mesmo a fazer. */
  function arrumarBotoesDeAluguer() {
    if (!fichaDeAluguer()) return;

    var rapidos = document.querySelectorAll(
      ".overlay-dynamic_buy_button, shopify-accelerated-checkout, "+
      ".shopify-payment-button, #shopify-buyer-consent"
    );
    for (var i = 0; i < rapidos.length; i++) rapidos[i].style.display = "none";

    var botoes = document.querySelectorAll(
      'button[name="add"], form[action*="/cart/add"] button, .product-form button'
    );
    for (var j = 0; j < botoes.length; j++) {
      if (/adicionar ao carrinho/i.test(botoes[j].textContent || "")) {
        trocarTexto(botoes[j], /Adicionar ao carrinho/i, "Reservar");
      }
    }
  }

  function aplicar() {
    calarContadorDeAluguer();
    arrumarBotoesDeAluguer();

    var novo;
    try {
      var hoje = emLisboa(new Date());
      if (typeof hoje.dia !== "number" || isNaN(hoje.minutos)) return;
      novo = textoDaEntrega(hoje);
    } catch (e) {
      // Sem Intl fiável mais vale deixar o texto do tema do que arriscar a
      // promessa errada.
      return;
    }

    // .overlay-valid é o ramo «há stock» do snippet; o .overlay-error (esgotado)
    // fica intocado de propósito.
    acertarContadorDoTema(novo);

    var caixas = document.querySelectorAll(".stock.overlay-valid");
    for (var i = 0; i < caixas.length; i++) {
      if (dentroDeAluguer(caixas[i])) continue;
      var filhos = caixas[i].children;
      for (var j = 0; j < filhos.length; j++) {
        if (filhos[j].tagName !== "SPAN") continue;
        var nos = filhos[j].childNodes;
        for (var k = 0; k < nos.length; k++) {
          // Mexer no nó de texto e não no innerHTML: o <i class="icon-check"> e
          // o tooltip .s1tt são irmãos dele e têm de sobreviver.
          if (nos[k].nodeType !== 3) continue;
          var atual = nos[k].nodeValue.trim();
          if (CONHECIDOS.indexOf(atual) === -1) continue;
          if (atual !== novo) nos[k].nodeValue = nos[k].nodeValue.replace(atual, novo);
          break;
        }
      }
    }
  }

  /* ---------------------------------------------------- recomendados ---- */

  /* Três sugestões por baixo da promessa de entrega, na ficha do produto.
   *
   * A ordem é a que a loja pediu: primeiro o que ENCAIXA (complementares,
   * escolhidos à mão na app Search & Discovery), depois o que é PARECIDO
   * (relacionados, escolhidos pelo algoritmo da Shopify).
   *
   * Nunca fica vazio. Se ninguém tiver escrito complementares para este
   * produto — que é o caso hoje em toda a loja — preenche-se com relacionados.
   * Um bloco vazio não ensina nada a ninguém; três parecidos pelo menos
   * mostram onde a coisa vai ficar.
   *
   * Só aparece com pelo menos um produto, e só na ficha (é onde existe o
   * input escondido com o id). */
  var RECO_QUANTOS = 3;

  function idDoProduto() {
    var i = document.querySelector('input[name="product-id"]');
    if (i && i.value) return i.value;
    try {
      return window.ShopifyAnalytics.meta.product.id;
    } catch (e) {
      return null;
    }
  }

  function pedirReco(id, intencao, quantos) {
    var url = "/recommendations/products.json?product_id=" + encodeURIComponent(id) +
      "&limit=" + quantos + "&intent=" + intencao;
    return fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j && j.products) || []; })
      .catch(function () { return []; });
  }

  /* O titulo vem da loja, mas passa na mesma por aqui.
     Um `&` num nome de produto chega para partir a marcacao, e nao ha razao
     para confiar em nada que se cole dentro de um `innerHTML`. */
  function escapar(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function euros(centimos) {
    return (centimos / 100).toFixed(2).replace(".", ",") + " €";
  }

  /* A variante que se mete no carrinho.
     A primeira que estiver disponivel. Nao havendo nenhuma, o cartao sai sem
     botao e leva a pessoa a ficha -- melhor nao oferecer do que oferecer e
     falhar no fim. */
  function varianteDe(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i] && vs[i].available && vs[i].id) return vs[i].id;
    }
    return null;
  }

  function cartaoReco(p) {
    /* O `featured_image` deste endereco e uma CADEIA, nao um objecto com
       `.url` -- ao contrario do que o /cart/add.js devolve para as linhas do
       carrinho. Escrevi `featured_image.url`, deu `undefined`, e os cartoes
       sairam todos sem imagem. */
    var img = p.featured_image || (p.images && p.images[0]) || "";
    if (img) img += (img.indexOf("?") === -1 ? "?" : "&") + "width=200";

    /* O riscado so quando e mesmo um desconto.
     *
     * Ha fichas neste catalogo com o `compare_at_price` ABAIXO do preco: a
     * primeira que abri tinha preco 150,00 e <<anterior>> 120,00. Mostrar isso
     * dava um desconto negativo por baixo de uma sugestao de compra. E a mesma
     * armadilha ja documentada no indexador da pesquisa, e a mesma regra. */
    var velho = p.compare_at_price > p.price
      ? '<s class="bukprod-reco__velho">' + euros(p.compare_at_price) + '</s> '
      : "";

    var vid = varianteDe(p);
    var botao = vid
      ? '<button type="button" class="bukprod-reco__add" data-vid="' + vid +
        '">Adicionar</button>'
      : "";

    /* O botao fica FORA da ligacao. Dentro dela, clicar nele navegava para a
       ficha antes de o carrinho saber de alguma coisa. */
    return '<div class="bukprod-reco__item">' +
      '<a class="bukprod-reco__ir" href="' + escapar(p.url) + '">' +
        (img ? '<img src="' + escapar(img) + '" alt="" loading="lazy">' : '<span></span>') +
        '<span class="bukprod-reco__nome">' + escapar(p.title) + "</span>" +
        '<span class="bukprod-reco__preco">' + velho + euros(p.price) + "</span>" +
      "</a>" + botao +
      "</div>";
  }

  /* Meter no carrinho a partir da sugestao.
   *
   * `fetch` e nao XMLHttpRequest, de proposito: a Shopify embrulha o `fetch`
   * e e por ai que avisa o tema de que o carrinho mudou. Com XHR o artigo
   * entrava mas o numero no cabecalho ficava a zero, e isso ja custou uma
   * tarde a perceber.
   *
   * E preciso refazer a gaveta: o tema desenha-a no servidor quando a pagina
   * carrega, portanto depois de metermos um artigo por fora ela abria vazia.
   */
  function meterNoCarrinhoReco(botao) {
    var vid = botao.getAttribute("data-vid");
    if (!vid || botao.disabled) return;

    var dizia = botao.textContent;
    botao.disabled = true;
    botao.textContent = "A juntar…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return fetch("/cart.js", { headers: { Accept: "application/json" } });
      })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        contadorDaLoja(carrinho);
        refazerGaveta();
        botao.textContent = "Adicionado";
        setTimeout(function () {
          botao.textContent = dizia;
          botao.disabled = false;
        }, 1600);
      })
      .catch(function (e) {
        console.warn("[bukprod] nao consegui juntar:", e && e.message);
        botao.textContent = dizia;
        botao.disabled = false;
      });
  }

  function contadorDaLoja(carrinho) {
    var n = (carrinho && carrinho.item_count) || 0;
    var ids = ["cart-count", "cart-count--m"];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el) el.textContent = String(n);
    }
    var cab = document.querySelector("#cart header[data-totalqty]");
    if (cab) cab.setAttribute("data-totalqty", String(n));
  }

  function refazerGaveta() {
    var actual = document.getElementById("cart");
    if (!actual) return;
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(raiz + "?sections=side-cart", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (seccoes) {
        if (!seccoes || !seccoes["side-cart"]) return;
        var caixa = document.createElement("div");
        caixa.innerHTML = seccoes["side-cart"];
        var nova = caixa.querySelector("#cart");
        if (nova) actual.innerHTML = nova.innerHTML;
      })
      .catch(function () { /* fica como estava */ });
  }

  function recomendados() {
    var alvo = document.querySelector(".f8pr-shipping-timer");
    if (!alvo || document.querySelector(".bukprod-reco")) return;

    var id = idDoProduto();
    if (!id) return;

    pedirReco(id, "complementary", RECO_QUANTOS).then(function (encaixam) {
      var faltam = RECO_QUANTOS - encaixam.length;
      if (faltam <= 0) return encaixam.slice(0, RECO_QUANTOS);

      // Plano B: o algoritmo da Shopify. Pede-se mais do que falta, porque
      // pode devolver produtos que ja vieram nos complementares.
      return pedirReco(id, "related", RECO_QUANTOS + 3).then(function (parecidos) {
        var vistos = {};
        for (var i = 0; i < encaixam.length; i++) vistos[encaixam[i].id] = 1;
        var juntos = encaixam.slice();
        for (var j = 0; j < parecidos.length && juntos.length < RECO_QUANTOS; j++) {
          if (vistos[parecidos[j].id]) continue;
          vistos[parecidos[j].id] = 1;
          juntos.push(parecidos[j]);
        }
        return juntos;
      });
    }).then(function (lista) {
      if (!lista || !lista.length) return;
      var caixa = document.createElement("div");
      caixa.className = "bukprod-reco";
      caixa.innerHTML = '<p class="bukprod-reco__titulo">Sugerimos também para este artigo:</p>' +
        '<div class="bukprod-reco__fila">' + lista.map(cartaoReco).join("") + "</div>";
      alvo.parentNode.insertBefore(caixa, alvo.nextSibling);

      caixa.addEventListener("click", function (e) {
        var b = e.target.closest && e.target.closest(".bukprod-reco__add");
        if (!b) return;
        e.preventDefault();
        meterNoCarrinhoReco(b);
      });
    }).catch(function (e) {
      // Sem sugestões a ficha fica como estava. Nunca vale a pena partir uma
      // página de produto por causa de um bloco de recomendações.
      console.warn("[bukprod] recomendados:", e && e.message);
    });
  }

  /* ------------------------------------------ recomendados no carrinho ---- */

  /* Duas sugestões na página do carrinho, por baixo dos artigos (24/10/2026).
   *
   * Não há motor novo: é o mesmo /recommendations/products.json da ficha, com a
   * mesma ordem — primeiro o que ENCAIXA (complementares do Search & Discovery,
   * que o pesquisa-ms escreve a partir da tabela de acessórios), depois o que é
   * PARECIDO (relacionados, do algoritmo da Shopify). A diferença é que aqui as
   * sementes são os artigos do carrinho, do último que entrou para o primeiro.
   *
   * A relevância comercial já vem de lá: o cruzar-acessorios só propõe o que
   * está em stock e, entre dois acessórios do mesmo género, o que mais se
   * vendeu. A margem não entra em lado nenhum — o browser não a conhece, e
   * não deve conhecer.
   *
   * O título não diz «ofertas exclusivas» de propósito: a loja não tem nenhuma
   * campanha só para o carrinho (os descontos activos são portes grátis e um
   * código de revenda). Uma etiqueta de oferta por cima de um preço normal era
   * prometer o que o checkout não cumpre. O riscado e o «Poupa» só aparecem
   * quando o próprio produto tem `compare_at_price` acima do preço — é o preço
   * que a Shopify cobra, não um desconto nosso.
   *
   * E também não diz «compatível»: o «encaixa» é o modelo a dizer de que
   * equipamento um artigo é acessório, não uma verificação técnica. Diz-se
   * «Acessório indicado para» e o nome do artigo do carrinho — que é verdade.
   *
   * Regras de fora:
   *   - nada do que já está no carrinho;
   *   - só produtos disponíveis, sem plano de subscrição;
   *   - alugueres só se o carrinho já tiver um aluguer (comprar um cabo e ver
   *     sugerido um pack de aluguer de 140 € não ajuda ninguém);
   *   - nos parecidos, nada do mesmo tipo de um artigo do carrinho: a quem leva
   *     uma máquina de fumos, outra máquina de fumos não completa nada, só
   *     compete com a que já escolheu. Os tipos mistos («Som e luz») não
   *     contam para isto — juntam coisas que não se substituem — e por isso
   *     olha-se também para a palavra principal do nome (cabeca());
   *   - com mais do que uma variante, não se escolhe por ninguém: o botão leva
   *     à ficha.
   *
   * O tema redesenha a secção inteira a cada mudança de quantidade (innerHTML
   * do #shopify-section-…), e leva o bloco com ela. Um observador nessa secção
   * volta a montá-lo, já com o carrinho novo — é isso que tira das sugestões o
   * que acabou de entrar. Os pedidos à Shopify ficam em memória, por isso
   * remontar não volta a perguntar o mesmo. */
  var CARRINHO_QUANTOS = 2;
  var CARRINHO_SEMENTES = 4;
  var recoMemoria = {};
  var carrinhoVez = 0;
  // O aviso de «adicionado» vive uns segundos e não só um redesenho: o tema
  // refaz a secção mais do que uma vez a seguir a cada mudança, e o aviso
  // desaparecia antes de alguém o conseguir ler.
  var carrinhoAviso = { texto: "", ate: 0 };

  function naPaginaDoCarrinho() {
    // Sem barras invertidas: isto vive dentro de uma string do Python.
    return /[/]cart[/]?$/.test(location.pathname);
  }

  function pedirRecoGuardado(id, intencao) {
    var chave = id + ":" + intencao;
    if (!recoMemoria[chave]) recoMemoria[chave] = pedirReco(id, intencao, 6);
    return recoMemoria[chave];
  }

  function eAluguer(titulo) {
    return /aluguer/i.test(titulo || "");
  }

  /* De que é o carrinho, para o título dizer alguma coisa.
   *
   * O tipo de produto desta loja tem 300 valores escritos à mão («Colunas
   * Ativas», «Maquinas Neblina», «Amplificadores de 100V»...), por isso
   * procura-se a família por palavras no tipo e no nome. Cabos, fichas e
   * suportes não contam: são eles próprios acessórios, e um carrinho só com
   * um cabo XLR não é «um sistema de som». Sem família, o título genérico. */
  var FAMILIAS = [
    { re: /fumo|neblina|haze|nevoeiro|m[aá]quina.{0,4}neve|co2|confetti|fa[ií]sca/i,
      titulo: "Completa os teus efeitos especiais" },
    { re: /(^|[^a-z])dj([^a-z]|$)|cdj|controladora|gira.?discos|vinil|turntable/i,
      titulo: "Completa o teu setup de DJ" },
    { re: /ilumina|laser|luz|l[aâ]mpada|projetor|moving|strobe|barra led|par led|bola de espelho/i,
      titulo: "Completa a tua iluminação" },
    { re: /amplific|coluna|altifalante|microfone|mesa.{0,4}(de )?(som|mistura)|subwoofer|interface de [aá]udio|auscultador|headphone/i,
      titulo: "Completa o teu sistema de som" },
  ];
  var NAO_E_EQUIPAMENTO = /cabo|ficha|adaptador|conector|suporte|tripé|tripe|flight|bolsa|capa|l[ií]quido/i;

  /* Primeiro o nome, depois o tipo. Há tipos que misturam famílias («Som e
     luz» serve para amplificadores e para barras LED), e esses não decidem
     nada: com eles, um amplificador saía «Completa a tua iluminação». */
  var TIPO_MISTO = /som e luz|categoria|novidades/i;

  function familiaDe(texto) {
    for (var f = 0; f < FAMILIAS.length; f++) {
      if (FAMILIAS[f].re.test(texto || "")) return FAMILIAS[f].titulo;
    }
    return null;
  }

  function tituloDoCarrinho(itens) {
    for (var i = 0; i < itens.length; i++) {
      var nome = itens[i].product_title || "";
      var tipo = itens[i].product_type || "";
      if (NAO_E_EQUIPAMENTO.test(nome)) continue;
      var t = familiaDe(nome) || (TIPO_MISTO.test(tipo) ? null : familiaDe(tipo));
      if (t) return t;
    }
    return "Completa a tua encomenda";
  }

  /* A palavra que diz o que a coisa é: «máquina», «amplificador», «coluna».
     Salta as que só embrulham («Aluguer», «Pack», «Kit», «2x»...). Serve para
     reconhecer uma alternativa ao que já está no carrinho quando o tipo não
     ajuda: a «Máquina de Nevoeiro» e a «Máquina de Fumo Jato» têm tipos
     diferentes, mas uma substitui a outra. */
  var EMBRULHO = { aluguer: 1, pack: 1, kit: 1, conjunto: 1, novo: 1, nova: 1, mini: 1, super: 1 };

  function cabeca(titulo) {
    var palavras = String(titulo || "").toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .split(/[^a-z]+/);
    for (var i = 0; i < palavras.length; i++) {
      var w = palavras[i];
      if (w.length >= 4 && !EMBRULHO[w]) return w;
    }
    return "";
  }

  /* As listas de cada semente entrelaçadas: a 1.ª de cada, depois a 2.ª de
     cada... Assim o último artigo que entrou não fica com as duas vagas só
     para ele. Cada sugestão leva consigo o artigo do carrinho que a trouxe. */
  function entrelacar(listas, sementes) {
    var out = [];
    for (var i = 0; ; i++) {
      var algum = false;
      for (var j = 0; j < listas.length; j++) {
        if (i < listas[j].length) {
          out.push({ p: listas[j][i], semente: sementes[j] });
          algum = true;
        }
      }
      if (!algum) return out;
    }
  }

  function sugestoesDoCarrinho(carrinho) {
    var itens = (carrinho && carrinho.items) || [];
    var noCarrinho = {};
    var tiposNoCarrinho = {};
    var cabecasNoCarrinho = {};
    var temAluguer = false;
    var sementes = [];
    for (var i = 0; i < itens.length; i++) {
      var pid = itens[i].product_id;
      if (eAluguer(itens[i].product_title)) temAluguer = true;
      var tipo = (itens[i].product_type || "").trim().toLowerCase();
      if (tipo) tiposNoCarrinho[tipo] = 1;
      var cab = cabeca(itens[i].product_title);
      if (cab) cabecasNoCarrinho[cab] = 1;
      if (!noCarrinho[pid]) {
        noCarrinho[pid] = 1;
        if (sementes.length < CARRINHO_SEMENTES) {
          sementes.push({ id: pid, titulo: itens[i].product_title || "" });
        }
      }
    }
    var resultado = { titulo: tituloDoCarrinho(itens), lista: [] };
    if (!sementes.length) return Promise.resolve(resultado);

    var vistos = {};
    function juntar(lista, origem) {
      for (var k = 0; k < lista.length && resultado.lista.length < CARRINHO_QUANTOS; k++) {
        var p = lista[k].p;
        if (!p || vistos[p.id] || noCarrinho[p.id]) continue;
        vistos[p.id] = 1;
        if (!p.available || p.requires_selling_plan) continue;
        if (eAluguer(p.title) && !temAluguer) continue;
        var tp = (p.type || "").trim().toLowerCase();
        if (origem === "parecido" && tp && !TIPO_MISTO.test(tp) && tiposNoCarrinho[tp]) continue;
        if (origem === "parecido" && cabecasNoCarrinho[cabeca(p.title)]) continue;
        resultado.lista.push({ p: p, origem: origem, semente: lista[k].semente });
      }
    }

    function porIntencao(intencao) {
      return Promise.all(sementes.map(function (s) {
        return pedirRecoGuardado(s.id, intencao);
      })).then(function (listas) { return entrelacar(listas, sementes); });
    }

    return porIntencao("complementary").then(function (encaixam) {
      juntar(encaixam, "encaixa");
      if (resultado.lista.length >= CARRINHO_QUANTOS) return resultado;
      return porIntencao("related").then(function (parecidos) {
        juntar(parecidos, "parecido");
        return resultado;
      });
    });
  }

  /* O que o cartão do próprio tema sabe e o JSON não diz: as estrelas e o
   * stock.
   *
   * As estrelas vêm das avaliações do Judge.me, que o tema desenha a partir
   * dos metafields do produto — o /recommendations/products.json não os traz.
   * O stock é o «1 em stock» do tema: o `available` do JSON também é
   * verdadeiro para artigos vendidos sem stock (encomenda ao fornecedor), e
   * prometer «Em stock» e «Receba já na terça» a esses era mentir.
   *
   * Pede-se à Shopify a MESMA recomendação desenhada pela secção
   * product-recommendations do tema (é o que a ficha usa), e lê-se o cartão
   * de cada produto. Um pedido por artigo do carrinho e por intenção, e só
   * para as que deram cartões. Se falhar, os cartões saem sem estrelas e sem
   * a faixa de stock — nunca com estrelas ou stock inventados. */
  var temaMemoria = {};

  function infoDoTema(id, intencao) {
    var chave = id + ":" + intencao;
    if (!temaMemoria[chave]) {
      temaMemoria[chave] = fetch("/recommendations/products?section_id=product-recommendations" +
        "&product_id=" + encodeURIComponent(id) + "&limit=10&intent=" + intencao)
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (html) {
          var info = {};
          if (!html) return info;
          var doc = new DOMParser().parseFromString(html, "text/html");
          // Cada cartão é um li.product-card com o produto num JSON dos
          // eventos da Shopify. O `data-product-id` desta secção está no
          // contentor (com o id do artigo de origem) e no botão da lista de
          // desejos — nenhum dos dois serve.
          var itens = doc.querySelectorAll("li.product-card[data-standard-product-select-product]");
          for (var i = 0; i < itens.length; i++) {
            var pid = "";
            try {
              pid = String(JSON.parse(itens[i].getAttribute("data-standard-product-select-product")).id || "");
            } catch (e) { pid = ""; }
            if (!pid || info[pid]) continue;
            var estrelas = itens[i].querySelector(".r6rt");
            info[pid] = {
              estrelas: estrelas && estrelas.querySelector(".rating") ? estrelas.outerHTML : "",
              emStock: !!itens[i].querySelector(".stock.overlay-valid"),
            };
          }
          return info;
        })
        .catch(function () { return {}; });
    }
    return temaMemoria[chave];
  }

  function juntarInfoDoTema(lista) {
    return Promise.all(lista.map(function (s) {
      var intencao = s.origem === "encaixa" ? "complementary" : "related";
      return infoDoTema(s.semente.id, intencao).then(function (info) {
        s.tema = info[String(s.p.id)] || null;
      });
    })).then(function () { return lista; });
  }

  /* Uma frase da descrição da ficha, para se perceber o que é sem lá ir.
     As fichas desta loja abrem quase sempre com o título repetido num <h1> e
     um «Descrição Geral» num <h2>, por isso salta-se para o primeiro
     parágrafo com texto a sério. */
  function resumoDe(p) {
    if (!p.description) return "";
    try {
      var doc = new DOMParser().parseFromString(p.description, "text/html");
      var ps = doc.querySelectorAll("p, li");
      for (var i = 0; i < ps.length; i++) {
        var t = (ps[i].textContent || "").replace(/[ ]+/g, " ").trim();
        // Muitas fichas começam por repetir o nome («X — Fichas, conectores
        // e adaptadores...»). O nome já está por cima: tira-se, e se sobrar
        // pouco não se mostra nada.
        var titulo = (p.title || "").trim();
        if (titulo && t.toLowerCase().indexOf(titulo.toLowerCase()) === 0) {
          t = t.slice(titulo.length).replace(/^[ ,.:;–—-]+/, "").trim();
        }
        // Frases de enchimento das fichas geradas em massa — dizem a marca ou
        // a loja e mais nada. Melhor sem descrição do que com esta.
        if (/^dispon[ií]vel na music stage/i.test(t)) continue;
        if (/^(categoria|marca|refer[eê]ncia|sku|ean)[ ]*:/i.test(t)) continue;
        if (t.length < 70 && /da marca [^.]+[.]?$/i.test(t)) continue;
        if (t.length >= 30) return t.length > 160 ? t.slice(0, 157).replace(/ [^ ]*$/, "") + "…" : t;
      }
    } catch (e) { /* sem resumo */ }
    return "";
  }

  // O ícone do carrinho, desenhado aqui para não depender da fonte de ícones
  // do tema, que muda de nomes entre versões.
  var ICONE_CARRINHO = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/>' +
    '<path d="M2.5 3.5h2.6l2.4 11.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2l1.7-7.3H6"/></svg>';
  var ICONE_VISTO = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">' +
    '<circle cx="12" cy="12" r="10"/><path d="m7.5 12.5 3 3 6-6.5"/></svg>';
  var ICONE_CAMIAO = '<svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M1.5 5.5h12v10h-12z"/><path d="M13.5 9h4l3 3.2v3.3h-7"/>' +
    '<circle cx="5.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';

  function entregaSemExclamacao() {
    var t = window.BUKPROD_ENTREGA ? window.BUKPROD_ENTREGA() : null;
    return t ? t.replace(/!$/, "") : "";
  }

  function cartaoCarrinho(s) {
    var p = s.p;
    var img = p.featured_image || (p.images && p.images[0]) || "";
    if (img) img += (img.indexOf("?") === -1 ? "?" : "&") + "width=300";

    var vs = p.variants || [];
    var unica = vs.length === 1 ? vs[0] : null;

    /* Com uma variante só, o preço e o anterior são os dela. Com várias, o
       `price` do produto é o mais baixo e o `compare_at_price` pode ser de
       outra variante — dizer «Poupa» com os dois misturados era inventar. */
    var preco, velho = "", poupa = "";
    if (unica) {
      preco = euros(unica.price);
      if (unica.compare_at_price > unica.price) {
        velho = '<s class="bukprod-cr__velho"><span class="bukprod-cr__lido">Antes </span>' +
          euros(unica.compare_at_price) + "</s>";
        poupa = '<span class="bukprod-cr__poupa">Poupa ' +
          euros(unica.compare_at_price - unica.price) + "</span>";
      }
    } else {
      preco = (p.price_varies ? "Desde " : "") + euros(p.price);
    }
    s.promo = !!poupa;

    var selo = poupa
      ? '<span class="bukprod-cr__selo bukprod-cr__selo--promo">Em promoção</span>'
      : (s.origem === "encaixa"
        ? '<span class="bukprod-cr__selo">Acessório indicado</span>'
        : '<span class="bukprod-cr__selo">Recomendado para ti</span>');

    var estrelas = s.tema && s.tema.estrelas ? s.tema.estrelas : "";
    var resumo = resumoDe(p);

    // Para que artigo do carrinho é. Só nos acessórios: nos parecidos dizer
    // «para» era afirmar uma ligação que ninguém verificou.
    var para = s.origem === "encaixa" && s.semente && s.semente.titulo
      ? '<p class="bukprod-cr__para">Para: ' + escapar(s.semente.titulo) + "</p>"
      : "";

    var botao;
    if (unica && unica.available) {
      botao = '<button type="button" class="bukprod-cr__add" data-vid="' + unica.id +
        '" data-pid="' + p.id + '" data-nome="' + escapar(p.title) + '">' + ICONE_CARRINHO +
        "<span>" + (eAluguer(p.title) ? "Reservar" : "Adicionar ao carrinho") + "</span></button>";
    } else {
      botao = '<a class="bukprod-cr__add bukprod-cr__add--ver" href="' + escapar(p.url) +
        '">Escolher opção</a>';
    }

    /* A faixa de baixo só com o que se sabe: «Em stock» quando o cartão do
       tema o diz, e a promessa de entrega da loja nesse caso (não num
       aluguer, que se combina e não segue por transportadora). */
    var rodape = "";
    if (s.tema && s.tema.emStock) {
      var entrega = eAluguer(p.title) ? "" : entregaSemExclamacao();
      rodape = '<p class="bukprod-cr__rodape">' +
        '<span class="bukprod-cr__ok-stock">' + ICONE_VISTO + "Em stock</span>" +
        (entrega ? "<span>" + ICONE_CAMIAO + escapar(entrega) + "</span>" : "") +
        "</p>";
    }

    return '<article class="bukprod-cr__item">' +
      '<a class="bukprod-cr__img" href="' + escapar(p.url) + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + escapar(img) + '" alt="" loading="lazy">' : "") +
      "</a>" +
      '<div class="bukprod-cr__info">' +
        selo +
        '<a class="bukprod-cr__nome" href="' + escapar(p.url) + '">' + escapar(p.title) + "</a>" +
        estrelas +
        (resumo ? '<p class="bukprod-cr__desc">' + escapar(resumo) + "</p>" : "") +
        para +
        '<p class="bukprod-cr__precos">' + velho +
          '<strong class="bukprod-cr__preco">' + preco + "</strong>" + poupa + "</p>" +
        botao +
        '<p class="bukprod-cr__erro" role="alert" hidden></p>' +
      "</div>" +
      rodape +
    "</article>";
  }

  /* Onde fica. No computador, por baixo dos artigos — o resumo e o «Finalizar
     compra» continuam sozinhos na coluna da direita. No telemóvel essa coluna
     cai para baixo dos artigos, e pôr as sugestões no meio empurrava o botão
     de pagar para fora do ecrã: aí vão para depois do resumo. */
  var telemovel = window.matchMedia ? window.matchMedia("(max-width: 760px)") : null;

  function colocarNoCarrinho(caixa) {
    var form = document.querySelector(".form-cart");
    if (!form) return false;
    var colunas = form.querySelector(".cols");
    var lista = form.querySelector(".cols > article > .bukprod-ca") ||
      form.querySelector(".cols > article > ul.l4ca");
    if (telemovel && telemovel.matches && colunas) {
      if (caixa.previousElementSibling !== colunas) {
        colunas.parentNode.insertBefore(caixa, colunas.nextSibling);
      }
    } else if (lista) {
      if (caixa.previousElementSibling !== lista) {
        lista.parentNode.insertBefore(caixa, lista.nextSibling);
      }
    } else {
      return false;
    }
    return true;
  }

  /* Meter no carrinho a partir daqui.
   *
   * Faz o mesmo que o addBulkItems do tema: o /cart/add.js leva o pedido das
   * secções da página e da gaveta, e a resposta já as traz desenhadas pela
   * Shopify — total, barra dos portes grátis, descontos. Põem-se no lugar e o
   * evento `ajaxCart` do tema volta a ligar os botões de quantidade, de
   * remover e do código de desconto (o tema marca os que já ligou, por isso
   * repetir não duplica nada).
   *
   * Não se usa o addBulkItems directamente porque ele abre a gaveta por cima
   * do carrinho — nesta página é um carrinho em cima do outro. Nem o
   * ajaxCart.refresh: no Xtra 8.3.0 pede as secções ao endereço actual, e em
   * /cart a Shopify responde com o JSON do carrinho em vez delas, por isso ele
   * falha sempre nesta página. Faltando alguma peça, recarrega-se: mais
   * lento, mas certo.
   *
   * O botão fica desligado do primeiro clique até a resposta chegar, para um
   * duplo clique não meter duas unidades. */
  function idDaSeccao(el) {
    var s = el && el.closest("[id^='shopify-section-']");
    return s ? s.id.replace("shopify-section-", "") : null;
  }

  function seccaoDaResposta(html, id, dentro) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var raiz = doc.getElementById(dentro || "shopify-section-" + id);
    return raiz ? raiz.innerHTML : null;
  }

  function redesenharCarrinho(resposta, idPagina, idGaveta) {
    var seccoes = (resposta && resposta.sections) || {};
    var pagina = seccaoDaResposta(seccoes[idPagina], idPagina);
    var raizPagina = document.getElementById("shopify-section-" + idPagina);
    if (pagina == null || !raizPagina) return false;

    raizPagina.innerHTML = pagina;
    var gaveta = document.getElementById("cart");
    var novaGaveta = idGaveta && seccaoDaResposta(seccoes[idGaveta], idGaveta, "cart");
    if (gaveta && novaGaveta != null) gaveta.innerHTML = novaGaveta;

    if (typeof window.updateAcceleratedCheckoutLayout === "function") {
      window.updateAcceleratedCheckoutLayout();
    }
    ["formValidate", "accordeon", "bindInput", "schemeTooltip", "popups", "ajaxCart"]
      .forEach(function (nome) { window.dispatchEvent(new CustomEvent(nome)); });
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(contadorDaLoja)
      .catch(function () {});
    return true;
  }

  /* Que sugestões acabaram mesmo em compra.
   *
   * Cada artigo metido a partir daqui fica anotado num atributo do carrinho,
   * `_bukprod_reco`, com o id do produto. O sublinhado à frente é a convenção
   * da Shopify para «interno»: não aparece a quem compra, mas segue com a
   * encomenda (e com o checkout abandonado), e é aí que o BukProd o lê para
   * contar quantas encomendas trouxeram uma sugestão, quanto valeram e com que
   * margem. Não mexe em linhas, preços nem descontos.
   *
   * Se falhar, falha calado: a compra vale mais do que a estatística. */
  var ultimoCarrinho = null;

  function anotarSugestao(pid) {
    if (!pid) return;
    var antes = (ultimoCarrinho && ultimoCarrinho.attributes &&
      ultimoCarrinho.attributes._bukprod_reco) || "";
    var ids = antes ? String(antes).split(",") : [];
    if (ids.indexOf(String(pid)) !== -1) return;
    ids.push(String(pid));
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: { _bukprod_reco: ids.join(",") } }),
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) ultimoCarrinho = c; })
      .catch(function () {});
  }

  function juntarDoCarrinho(botao) {
    var vid = botao.getAttribute("data-vid");
    if (!vid || botao.disabled) return;
    var item = botao.closest(".bukprod-cr__item");
    var erro = item && item.querySelector(".bukprod-cr__erro");
    var dizia = botao.innerHTML;
    botao.disabled = true;
    botao.setAttribute("aria-busy", "true");
    botao.textContent = "A adicionar…";
    if (erro) erro.hidden = true;

    var idPagina = idDaSeccao(document.querySelector(".form-cart"));
    var gaveta = document.getElementById("cart");
    var idGaveta = gaveta && (gaveta.getAttribute("data-section-id") || idDaSeccao(gaveta));
    var pedido = { items: [{ id: Number(vid), quantity: 1 }] };
    var seccoes = [idPagina, idGaveta].filter(Boolean);
    if (seccoes.length) pedido.sections = seccoes.join(",");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(pedido),
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) {
            throw new Error((j && (j.description || j.message)) ||
              "Não foi possível adicionar este artigo.");
          }
          return j;
        });
      })
      .then(function (resposta) {
        carrinhoAviso = {
          texto: "«" + (botao.getAttribute("data-nome") || "Artigo") + "» foi adicionado ao carrinho.",
          ate: Date.now() + 8000,
        };
        botao.textContent = "Adicionado ✓";
        anotarSugestao(botao.getAttribute("data-pid"));
        var feito = false;
        try { feito = redesenharCarrinho(resposta, idPagina, idGaveta); } catch (e) { feito = false; }
        if (!feito) location.reload();
      })
      .catch(function (e) {
        botao.innerHTML = dizia;
        botao.disabled = false;
        botao.removeAttribute("aria-busy");
        if (erro) {
          erro.textContent = (e && e.message) || "Não foi possível adicionar este artigo.";
          erro.hidden = false;
        }
      });
  }

  /* ----------------------------------- a página do carrinho, arrumada ---- */

  /* O resto da página, como no desenho pedido (24/10/2026): os artigos numa
   * caixa com título, o código de desconto aberto, um «Resumo da encomenda»
   * com Subtotal, IVA e Total, a seta no «Finalizar compra», os meios de
   * pagamento e uma faixa de garantias por baixo.
   *
   * Nada disto é desenhado de novo: os blocos do tema são MOVIDOS para dentro
   * das caixas, e um elemento movido leva consigo os comportamentos que o
   * tema lhe ligou (quantidades, remover, desconto, notas, checkout). Corre
   * outra vez sempre que o tema redesenha a secção, e cada passo vê primeiro
   * se já está feito.
   *
   * Só se diz o que é verdade:
   *   - os números do resumo vêm do /cart.js, os mesmos que o checkout usa;
   *   - os meios de pagamento são os que o checkout mostrou a 24/10/2026
   *     (Multibanco, MB WAY, transferência). Se a loja ligar ou desligar
   *     algum, é aqui em MEIOS_DE_PAGAMENTO que se muda;
   *   - os 14 dias são o direito de livre resolução das compras à distância,
   *     e não se dizem nos alugueres;
   *   - a entrega é a mesma regra da loja (window.BUKPROD_ENTREGA). */
  var MEIOS_DE_PAGAMENTO = ["Multibanco", "MB WAY", "Transferência bancária"];

  var ICONE_DEVOLVER = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>';
  var ICONE_SETA = '<svg class="bukprod-seta" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" ' +
    'fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>';
  var ICONE_ESCUDO = '<svg aria-hidden="true" width="30" height="30" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M12 2.5 4 5.5v6c0 5 3.4 8.6 8 10 4.6-1.4 8-5 8-10v-6z"/><path d="m8.5 12 2.5 2.5 4.5-5"/></svg>';
  var ICONE_CAIXA = '<svg aria-hidden="true" width="30" height="30" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M12 2.5 3 7v10l9 4.5 9-4.5V7z"/><path d="M3 7l9 4.5L21 7"/><path d="M12 11.5v10"/></svg>';
  var ICONE_CAMIAO_G = ICONE_CAMIAO.replace('width="15" height="15"', 'width="30" height="30"');

  function arrumarCarrinho(c) {
    var form = document.querySelector(".form-cart");
    if (!form) return;
    var artigo = form.querySelector(".cols > article");
    var aside = form.querySelector(".cols > aside");

    // 0. A barra dos portes grátis com o camião (e o visto quando já tem).
    var barras = form.querySelectorAll("ul.l4al.inline > li");
    for (var bi = 0; bi < barras.length; bi++) {
      var bl = barras[bi];
      if (bl.querySelector(".bukprod-pg__ic")) continue;
      bl.insertAdjacentHTML("afterbegin", '<span class="bukprod-pg__ic">' +
        ICONE_CAMIAO.replace('width="15" height="15"', 'width="28" height="28"') + "</span>");
      if (bl.classList.contains("overlay-lime")) {
        bl.insertAdjacentHTML("beforeend", '<span class="bukprod-pg__ok">' +
          ICONE_VISTO.replace('width="14" height="14"', 'width="24" height="24"') + "</span>");
      }
    }

    // 1. Os artigos numa caixa com título.
    var lista = artigo && (artigo.querySelector(":scope > ul.l4ca") ||
      artigo.querySelector(":scope > .bukprod-ca > ul.l4ca"));
    if (lista && !(lista.parentNode.classList && lista.parentNode.classList.contains("bukprod-ca"))) {
      var caixa = document.createElement("div");
      caixa.className = "bukprod-ca";
      caixa.innerHTML = '<h2 class="bukprod-ca__titulo">Os teus artigos</h2>';
      lista.parentNode.insertBefore(caixa, lista);
      caixa.appendChild(lista);
    }
    var tituloArtigos = form.querySelector(".bukprod-ca__titulo");
    if (tituloArtigos && c) tituloArtigos.textContent = "Os teus artigos (" + c.item_count + ")";

    // 2. Os 14 dias por baixo de cada artigo que é uma compra.
    if (lista) {
      var linhas = lista.querySelectorAll(":scope > li");
      for (var i = 0; i < linhas.length; i++) {
        var li = linhas[i];
        if (li.querySelector(".bukprod-ca__dev")) continue;
        var nome = li.querySelector("h2 a, h3 a");
        var sec = li.querySelector(":scope > section");
        if (!sec || !nome || eAluguer(nome.textContent)) continue;
        var dev = document.createElement("span");
        dev.className = "bukprod-ca__dev";
        dev.innerHTML = ICONE_DEVOLVER + "14 dias para devolução";
        sec.appendChild(dev);
      }
    }

    if (!aside) return;

    // 3. O código de desconto aberto, como no desenho. Só na primeira vez:
    //    quem o fechar não o vê abrir outra vez sozinho.
    var det = aside.querySelector(".accordion-a details");
    if (det && !det.getAttribute("data-bukprod")) {
      det.setAttribute("data-bukprod", "1");
      det.open = arrumarCarrinho.aberto !== false;
      det.addEventListener("toggle", function () { arrumarCarrinho.aberto = det.open; });
    }

    // 4. O contador «Receba já amanhã!» numa caixa, quando o tema o mostra.
    var contador = aside.querySelector(":scope > ul.l4us");
    if (contador) contador.classList.toggle("bukprod-tem", !!contador.querySelector("li"));

    // 5. O resumo.
    var pagar = aside.querySelector(":scope > form.f8vl, :scope > .bukprod-resumo > form.f8vl");
    var resumo = aside.querySelector(":scope > .bukprod-resumo");
    if (pagar && !resumo) {
      resumo = document.createElement("div");
      resumo.className = "bukprod-resumo";
      resumo.innerHTML = '<h2 class="bukprod-resumo__titulo">Resumo da encomenda</h2>' +
        '<div class="bukprod-resumo__linhas"></div>';
      var primeiro = aside.querySelector(":scope > hr") || pagar;
      aside.insertBefore(resumo, primeiro);
      var mover = [aside.querySelector(":scope > hr"),
        aside.querySelector(":scope > span.mobile-hide"),
        aside.querySelector(":scope > span.cart-tax-text"), pagar];
      for (var m = 0; m < mover.length; m++) if (mover[m]) resumo.appendChild(mover[m]);
      var meios = document.createElement("p");
      meios.className = "bukprod-pagar";
      meios.innerHTML = '<span class="bukprod-pagar__rotulo">Pagamentos aceites:</span>' +
        MEIOS_DE_PAGAMENTO.map(function (n) {
          return '<span class="bukprod-pagar__meio">' + escapar(n) + "</span>";
        }).join("");
      resumo.appendChild(meios);
    }
    if (resumo && c) {
      var ivaIncluido = /IVA inclu/i.test(aside.textContent || "");
      var html =
        '<p class="bukprod-resumo__linha"><span>Subtotal (' + c.item_count + ")</span><span>" +
          euros(c.items_subtotal_price) + "</span></p>";
      if (c.total_price < c.items_subtotal_price) {
        html += '<p class="bukprod-resumo__linha bukprod-resumo__linha--desc"><span>Descontos</span><span>−' +
          euros(c.items_subtotal_price - c.total_price) + "</span></p>";
      }
      if (ivaIncluido) {
        html += '<p class="bukprod-resumo__linha"><span>IVA</span><span>Incluído</span></p>';
      }
      resumo.querySelector(".bukprod-resumo__linhas").innerHTML = html +
        '<p class="bukprod-resumo__total"><span>Total</span><strong>' + euros(c.total_price) + "</strong></p>";
    }

    // 6. A seta no «Finalizar compra».
    var botaoPagar = aside.querySelector('button[name="checkout"] > span:last-child');
    if (botaoPagar && !botaoPagar.querySelector(".bukprod-seta")) {
      botaoPagar.insertAdjacentHTML("beforeend", ICONE_SETA);
    }

    // 7. A faixa das garantias, por baixo das duas colunas.
    var fieldset = form.querySelector("fieldset");
    if (fieldset && !fieldset.querySelector(".bukprod-garantias")) {
      var entrega = entregaSemExclamacao() || "Enviamos em 24 horas";
      var g = document.createElement("div");
      g.className = "bukprod-garantias";
      g.innerHTML =
        "<div>" + ICONE_CAMIAO_G + "<span><strong>Envios rápidos</strong><span>" + escapar(entrega) + "</span></span></div>" +
        "<div>" + ICONE_ESCUDO + "<span><strong>Compra segura</strong><span>Pagamento seguro e encriptado</span></span></div>" +
        "<div>" + ICONE_CAIXA + "<span><strong>Devoluções fáceis</strong><span>14 dias para devolver</span></span></div>";
      fieldset.appendChild(g);
    }
  }

  /* O subtítulo diz o que as sugestões são, e não mais do que isso. */
  function subtituloDe(lista) {
    var acessorios = 0;
    for (var i = 0; i < lista.length; i++) if (lista[i].origem === "encaixa") acessorios++;
    if (acessorios === lista.length) return "Acessórios indicados para os artigos do teu carrinho.";
    if (acessorios) return "Acessórios e sugestões para os artigos do teu carrinho.";
    return "Escolhidos a partir dos artigos do teu carrinho.";
  }

  function montarNoCarrinho() {
    var antigo = document.querySelector(".bukprod-cr");
    if (!document.querySelector(".form-cart")) {
      // Carrinho vazio: sem artigos não há de onde sugerir.
      if (antigo) antigo.remove();
      return;
    }
    var vez = ++carrinhoVez;
    // A estrutura já, os números quando o /cart.js chegar: sem isto a página
    // aparecia um instante como o tema a desenha e depois mudava de forma.
    arrumarCarrinho(null);

    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        ultimoCarrinho = c;
        if (vez === carrinhoVez) arrumarCarrinho(c);
        return sugestoesDoCarrinho(c);
      })
      .then(function (res) {
        return juntarInfoDoTema(res.lista).then(function () { return res; });
      })
      .then(function (res) {
        var lista = res.lista;
        if (vez !== carrinhoVez) return;          // chegou outra mudança entretanto
        var velho = document.querySelector(".bukprod-cr");
        if (velho) velho.remove();
        var aviso = Date.now() < carrinhoAviso.ate ? carrinhoAviso.texto : "";
        if (!lista.length) return;

        var cartoes = lista.map(cartaoCarrinho).join("");
        var promo = lista.some(function (s) { return s.promo; });
        var caixa = document.createElement("section");
        caixa.className = "bukprod-cr" + (promo ? " bukprod-cr--promo" : "");
        caixa.setAttribute("aria-labelledby", "bukprod-cr-titulo");
        caixa.innerHTML =
          '<header class="bukprod-cr__cab">' +
            '<span class="bukprod-cr__icone" aria-hidden="true">' + (promo ? "%" : "+") + "</span>" +
            "<div>" +
              '<h2 class="bukprod-cr__titulo" id="bukprod-cr-titulo">' + escapar(res.titulo) + "</h2>" +
              '<p class="bukprod-cr__sub">' + subtituloDe(lista) + "</p>" +
            "</div>" +
          "</header>" +
          '<p class="bukprod-cr__ok" role="status"' + (aviso ? "" : " hidden") + ">" +
            escapar(aviso) + "</p>" +
          '<div class="bukprod-cr__fila">' + cartoes + "</div>" +
          /* Para quem procura outra coisa: a página dos cabos, fichas e
             adaptadores, que é a do menu. Não diz «compatíveis» — é a gama
             toda, e quem escolhe é a pessoa. */
          '<p class="bukprod-cr__mais"><span><strong>Precisa de cabos ou outro acessório?</strong>' +
            "Temos cabos, fichas e adaptadores para montar o teu equipamento.</span>" +
            '<a href="/pages/cabos-de-audio">Ver cabos e acessórios →</a></p>';
        if (!colocarNoCarrinho(caixa)) return;

        caixa.addEventListener("click", function (e) {
          var b = e.target.closest && e.target.closest("button.bukprod-cr__add");
          if (!b) return;
          e.preventDefault();
          juntarDoCarrinho(b);
        });
      })
      .catch(function (e) {
        // Sem sugestões o carrinho fica como estava — nunca partir a página
        // de pagar por causa delas.
        console.warn("[bukprod] carrinho:", e && e.message);
      });
  }

  function recomendadosNoCarrinho() {
    if (!naPaginaDoCarrinho()) return;
    var form = document.querySelector(".form-cart, .cart-empty");
    var seccao = form && form.closest("[id^='shopify-section-']");
    if (!seccao) return;
    montarNoCarrinho();

    // Só os filhos directos da secção: é aí que o tema troca o conteúdo.
    // O nosso bloco entra mais abaixo, por isso pô-lo não volta a disparar.
    if (window.MutationObserver) {
      new MutationObserver(montarNoCarrinho).observe(seccao, { childList: true });
    }
    if (telemovel) {
      var mudar = function () {
        var c = document.querySelector(".bukprod-cr");
        if (c) colocarNoCarrinho(c);
      };
      if (telemovel.addEventListener) telemovel.addEventListener("change", mudar);
      else if (telemovel.addListener) telemovel.addListener(mudar);
    }
  }

  /* A altura real do cabecalho, em pixeis, para o rasto de navegacao saber
     onde encostar.
     
     Nao se pode escrever a medida a mao: o cabecalho muda de altura com a
     largura da janela, com o tamanho de letra que a pessoa escolher no botao
     de acessibilidade, e com a faixa de cima a aparecer ou nao. Mede-se o
     elemento e publica-se o valor numa variavel que o CSS le. */
  var alturaCabecalho = 0;

  function medirCabecalho() {
    var topo = document.querySelector(".shopify-section-header");
    if (!topo) return;
    var h = Math.round(topo.offsetHeight);
    if (h && h !== alturaCabecalho) {
      alturaCabecalho = h;
      document.documentElement.style.setProperty("--ms-cabecalho-h", h + "px");
    }
  }

  function vigiarCabecalho() {
    var topo = document.querySelector(".shopify-section-header");
    if (!topo) return;
    medirCabecalho();

    // As letras de encomenda chegam depois do DOMContentLoaded e mudam a
    // altura em um ou dois pixeis. Medir so uma vez deixava o rasto
    // desencostado por uma frincha.
    window.addEventListener("load", medirCabecalho);

    if (window.ResizeObserver) {
      new ResizeObserver(medirCabecalho).observe(topo);
    } else {
      window.addEventListener("resize", medirCabecalho);
    }
  }

  function arrancar() {
    aplicar();
    vigiarCabecalho();
    recomendados();
    recomendadosNoCarrinho();

    // Os cartões são redesenhados a cada filtro, ordenação ou página do tema.
    // Observamos só childList: mudar um nodeValue não dispara este observer,
    // por isso não há ciclo.
    if (window.MutationObserver) {
      new MutationObserver(function (mudancas) {
        for (var i = 0; i < mudancas.length; i++) {
          if (mudancas[i].addedNodes.length) { aplicar(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    // Separador deixado aberto por cima das 16h ou da meia-noite: sem isto a
    // promessa fica congelada na que estava certa à hora do carregamento.
    setInterval(aplicar, 10 * 60 * 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arrancar);
  } else {
    arrancar();
  }
})();

/* ---------------------------------------------------------------------------
   Pesquisa: exigir os termos em vez de os sugerir.

   A pesquisa da Shopify, com o termo solto, faz duas coisas más ao mesmo tempo:
   soma os termos por OU em vez de os exigir todos, e alarga-os a palavras
   parecidas. Medido nesta loja, a 08/09/2026:

       megafone           72 resultados   ("megafone")           9
       megafone bateria  276 resultados   ("megafone" "bateria") 6
       coluna ativa      381 resultados   ("coluna" "ativa")    15
       cabo xlr         1000 resultados   ("cabo" "xlr")       172

   Os 72 de «megafone» incluem oito microfones — e nenhum deles tem a palavra
   megafone no título, nas tags, no tipo, na marca, na descrição ou no SEO. É a
   Shopify a casar «microfone» com «megafone» pelo «fone» que partilham.

   Pôr cada termo entre aspas desliga as duas coisas. O que se perde é a
   tolerância a gralhas — «megafona» com aspas dá zero — e é por isso que existe
   a rede: dando zero, repete-se a pesquisa como a pessoa a escreveu e diz-se-lhe
   porquê. Prefixos não se perdem, que a Shopify já não os fazia: «megaf» dá zero
   nos dois casos.

   Duas entradas, porque a pesquisa tem duas portas: o formulário (a maioria,
   sem custo nenhum) e o endereço já feito — link do dropdown, favorito, Google —
   que só se pode corrigir a chegar, com um salto.
--------------------------------------------------------------------------- */
(function () {
  "use strict";

  var MARCA = "bp";          // 1 = já pusemos aspas · 0 = rede, não voltar a pôr

  // O Google tem de indexar o que a loja responde a um termo, não a nossa
  // reescrita dele.
  var ua = navigator.userAgent || "";
  if (/bot|crawl|spider|slurp|bingpreview|lighthouse|headless/i.test(ua)) return;

  /** Cada termo entre aspas, ou null quando não se deve mexer.
   *
   *  Não se mexe em quem já escreveu aspas, nem em quem usou a sintaxe da
   *  Shopify (`title:`, `*`, AND/OR/NOT, `-fora`): essas pessoas sabem o que
   *  querem e embrulhar-lhes os termos estragava a consulta. */
  function comAspas(q) {
    var texto = (q || "").trim();
    if (!texto || texto.indexOf('"') !== -1) return null;
    if (/[:*()]/.test(texto)) return null;
    var termos = texto.split(/\s+/).filter(Boolean);
    if (!termos.length) return null;
    for (var i = 0; i < termos.length; i++) {
      if (/^(AND|OR|NOT)$/i.test(termos[i]) || termos[i].charAt(0) === "-") return null;
    }
    return termos.map(function (t) { return '"' + t + '"'; }).join(" ");
  }

  /* --- Porta 1: o formulário. Sai já com aspas, sem salto nenhum. --------- */
  document.addEventListener("submit", function (ev) {
    var form = ev.target;
    if (!form || form.tagName !== "FORM") return;
    var accao = form.getAttribute("action") || "";
    if (accao.indexOf("/search") === -1) return;

    var campo = form.querySelector('input[name="q"]');
    if (!campo) return;
    var novo = comAspas(campo.value);
    if (!novo) return;

    campo.value = novo;
    if (!form.querySelector('input[name="' + MARCA + '"]')) {
      var marca = document.createElement("input");
      marca.type = "hidden";
      marca.name = MARCA;
      marca.value = "1";
      form.appendChild(marca);
    }
  }, true);

  /* --- Porta 2: já cá dentro. O salto custa um carregamento, e por isso só
         se dá a quem chegou sem passar pelo formulário. -------------------- */
  if (location.pathname.indexOf("/search") !== 0) return;

  var params = new URLSearchParams(location.search);
  var q = params.get("q");
  if (!q) return;
  var marca = params.get(MARCA);

  function ir(novoQ, novaMarca) {
    params.set("q", novoQ);
    params.set(MARCA, novaMarca);
    // `replace` e não `assign`: o botão de voltar tem de sair da pesquisa, não
    // passear pelas nossas reescritas dela.
    location.replace(location.pathname + "?" + params.toString());
  }

  if (marca === null) {
    var apertado = comAspas(q);
    if (apertado) { ir(apertado, "1"); return; }
    marca = "0";                      // nada a apertar aqui: segue como está
  }

  /* As aspas são para a Shopify, não para quem procura.
   *
   *  Depois do salto, a caixa fica a dizer «"megafone"» e o título «Resultados
   *  da pesquisa para ""megafone""». Quem escreveu não pôs aspas nenhumas e não
   *  tem de perceber porque é que elas apareceram.
   *
   *  Limpa-se o que se vê e não o endereço: os links da paginação e dos filtros
   *  são desenhados pelo tema a partir da consulta a sério, e reescrever a barra
   *  de endereço arriscava que o clique seguinte fosse buscar os 72 outra vez. */
  function limparAspas() {
    var visto = q.replace(/"/g, "").trim();
    if (!visto || visto === q) return;

    var caixas = document.querySelectorAll('input[name="q"]');
    for (var i = 0; i < caixas.length; i++) {
      if (caixas[i].value.indexOf('"') !== -1) caixas[i].value = visto;
    }

    // O tema põe o termo dentro das suas próprias aspas, por isso o que aqui
    // aparece é «""megafone""». Trocar o termo inteiro resolve os dois casos.
    var titulos = document.querySelectorAll("h1, h2, h3");
    for (var j = 0; j < titulos.length; j++) {
      var t = titulos[j];
      if (t.children.length) continue;          // não desmontar títulos com marcação
      if (t.textContent.indexOf(q) === -1) continue;
      t.textContent = t.textContent.split(q).join(visto);
    }
  }

  // A rede. O tema escreve a contagem no wrapper — não é preciso perguntar
  // outra vez ao servidor para saber que deu zero.
  function arrancar() {
    var caixa = document.querySelector("[data-standard-results-count]");
    if (!caixa) return;
    if (parseInt(caixa.getAttribute("data-standard-results-count"), 10) !== 0) return;
    var solto = q.replace(/"/g, "").trim();
    if (!solto || solto === q) return;
    try { sessionStorage.setItem("bukprod:pesquisa-alargada", solto); } catch (e) {}
    ir(solto, "0");
  }

  /* O aviso, na página alargada: quem procurou «megafona» tem de perceber que
     o que está a ver não é o que escreveu.

     O aviso entra na COLUNA dos resultados, não na caixa que a contém. A caixa
     (`.m6cl`) é a linha do tema: uma flex-row invertida com duas colunas — os
     resultados de um lado, o <aside> dos filtros do outro — e `> * {width:100%}`
     em cima. Pendurar lá um terceiro filho fazia dele uma terceira coluna: o
     aviso encostado à direita, com a grelha de produtos espremida a meia
     largura e meio ecrã em branco ao lado. */
  function avisar() {
    var termo;
    try { termo = sessionStorage.getItem("bukprod:pesquisa-alargada"); } catch (e) { return; }
    if (!termo || termo !== q) return;
    try { sessionStorage.removeItem("bukprod:pesquisa-alargada"); } catch (e) {}
    var caixa = document.querySelector("[data-standard-results-count]");
    if (!caixa) return;
    if (caixa.querySelector(".bukprod-pesquisa-alargada")) return;

    // A coluna dos resultados é o primeiro filho que não é o <aside> dos filtros.
    var coluna = null;
    for (var i = 0; i < caixa.children.length; i++) {
      if (caixa.children[i].tagName !== "ASIDE") { coluna = caixa.children[i]; break; }
    }
    if (!coluna) return;

    // Logo por baixo do título: é a seguir a «Resultados da pesquisa para X»
    // que faz falta dizer que X não existe tal e qual.
    var depois = coluna.firstChild;
    for (var j = 0; j < coluna.children.length; j++) {
      if (coluna.children[j].tagName === "HEADER") {
        depois = coluna.children[j].nextSibling;
        break;
      }
    }

    var nota = document.createElement("p");
    nota.className = "bukprod-pesquisa-alargada";
    nota.textContent = "Não há nada com «" + termo + "» tal e qual. Isto é o que mais se aproxima.";
    coluna.insertBefore(nota, depois);
  }

  function agora() {
    if (marca === "1") { limparAspas(); arrancar(); }
    else avisar();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", agora);
  } else {
    agora();
  }
})();

/* ---------------------------------------------------------------------------
   A bolha «Precisa de ajuda?» não fica por cima da faixa dos cookies.

   As duas vivem no fundo do ecrã: a faixa é a do consentimento da Shopify (que
   este ficheiro já passou a tira fina) e a bolha é do Shopify Inbox. Com a
   faixa aberta, a bolha tapava o «Rejeitar» e o «Gerir preferências» — e
   recusar tem de ser tão fácil como aceitar.

   O Inbox já tem a variável certa para isto, --shopify-chat-activator-offset
   (20px de origem, no :root). Enquanto a faixa estiver à vista sobe-se a
   bolha a altura dela mais esses 20px; quando a faixa sai, tira-se o valor e
   volta o da app. Posto no próprio <html>, ganha ao :root da app sem
   `!important`, e não se toca em nada dentro do componente dela.

   A faixa aparece tarde e desaparece com um clique, e não há evento para
   nenhuma das duas coisas: espreita-se uma vez por segundo, e pára-se quando
   a faixa já saiu ou ao fim de cinco minutos.
--------------------------------------------------------------------------- */
(function () {
  "use strict";

  var FOLGA = 20;            // o mesmo afastamento que a app usa de origem
  var raiz = document.documentElement;
  var vista = false;
  var voltas = 0;

  function faixaAberta() {
    var f = document.getElementById("shopify-pc__banner");
    if (!f || !f.isConnected) return 0;
    var e = getComputedStyle(f);
    if (e.display === "none" || e.visibility === "hidden" || e.opacity === "0") return 0;
    var r = f.getBoundingClientRect();
    // Só conta se estiver mesmo encostada ao fundo do ecrã.
    if (!r.height || r.bottom < window.innerHeight - 2) return 0;
    return Math.ceil(r.height);
  }

  /* A barra do carrinho da pesquisa, quando está fixa no fundo (página de
     coleção, ms-search.css). A bolha também tem de lhe ficar por cima. */
  function barraDoCarrinho() {
    var b = document.querySelector(".msc--pagina .msc__carrinho:not([hidden])");
    if (!b || getComputedStyle(b).position !== "fixed") return 0;
    return Math.ceil(b.getBoundingClientRect().height);
  }

  function acertar() {
    var h = faixaAberta();
    var total = h + barraDoCarrinho();
    // --ms-faixa-baixo é para a barra do carrinho da pesquisa, que sobe a
    // altura da faixa dos cookies; a bolha sobe as duas juntas.
    if (h) {
      vista = true;
      raiz.style.setProperty("--ms-faixa-baixo", h + "px");
    } else {
      raiz.style.removeProperty("--ms-faixa-baixo");
    }
    if (total) {
      raiz.style.setProperty("--shopify-chat-activator-offset", (total + FOLGA) + "px");
    } else {
      raiz.style.removeProperty("--shopify-chat-activator-offset");
    }
    return h;
  }

  var relogio = setInterval(function () {
    voltas++;
    var h = acertar();
    if ((vista && !h) || voltas > 300) clearInterval(relogio);
  }, 1000);
  window.addEventListener("resize", acertar);
  document.addEventListener("click", function () { setTimeout(acertar, 400); }, true);

  // A barra da pesquisa aparece e desaparece com o carrinho, e avisa pela
  // classe msc-com-carrinho no <html>: é esse o sinal para voltar a medir.
  if (window.MutationObserver) {
    new MutationObserver(function () { setTimeout(acertar, 50); })
      .observe(raiz, { attributes: true, attributeFilter: ["class"] });
  }
})();

/* ---------------------------------------------------------------------------
   Cabeçalho: «Todas as coleções» na barra do menu, Promoções e Novidades.

   Pedido do César (24/10/2026), com uma referência desenhada: o botão
   «Todas as coleções» por baixo do logótipo, no início da barra do menu, e
   duas pastilhas à direita — Promoções (a coleção automática «promocoes»,
   artigos com o preço baixado) e Novidades (a coleção «Novos Artigos»).

   O botão é o do próprio tema, MOVIDO e não copiado: um elemento movido leva
   consigo o que o tema lhe ligou, e é ele que abre o menu. Se um dia o tema
   não o tiver, fica uma ligação simples para /collections.

   Só no computador: no telemóvel o tema tem o seu menu, e estas três
   entradas já lá estão (ou cabem no menu do tema).
--------------------------------------------------------------------------- */
(function () {
  "use strict";
  var LIGACOES = [
    { cls: "bukprod-pill--promo", href: "/collections/promocoes", txt: "Promoções",
      ico: '<path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/>' },
    { cls: "bukprod-pill--novo", href: "/collections/novos-artigos-music-stage", txt: "Novidades",
      ico: '<path d="m12 3 2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.6 6.6 19.5l1.2-6L3.3 9.3l6.1-.7z"/>' },
  ];
  var RISCAS = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round"><path d="M4 7h16M4 12h16M4 17h16"/></svg>';

  function icone(d) {
    return '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + d + "</svg>";
  }

  function cabecalhoArrumado() {
    if (window.matchMedia && !window.matchMedia("(min-width: 1001px)").matches) return;
    var barra = document.querySelector("#nav-bar > ul");
    if (!barra || barra.querySelector(".bukprod-nb")) return;

    var li = document.createElement("li");
    li.className = "bukprod-nb bukprod-nb--todas";
    var botao = document.querySelector('.link-btn > a[aria-controls="nav"]');
    if (botao) {
      var origem = botao.parentNode;
      li.appendChild(botao);
      if (!origem.querySelector("a:not(.search-compact)")) origem.classList.add("bukprod-nb-movido-vazio");
    } else {
      var a = document.createElement("a");
      a.href = "/collections";
      a.textContent = "Todas as coleções";
      li.appendChild(a);
    }
    var primeiro = li.querySelector("a");
    if (primeiro && !primeiro.querySelector(".bukprod-riscas")) {
      primeiro.insertAdjacentHTML("afterbegin", '<span class="bukprod-riscas">' + RISCAS + "</span>");
      primeiro.insertAdjacentHTML("beforeend",
        '<svg class="bukprod-seta-baixo" aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" ' +
        'stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>');
    }
    barra.insertBefore(li, barra.firstChild);

    var extra = document.createElement("li");
    extra.className = "bukprod-nb bukprod-nb--extra";
    extra.innerHTML = LIGACOES.map(function (l) {
      return '<a class="bukprod-pill ' + l.cls + '" href="' + l.href + '">' + icone(l.ico) + l.txt + "</a>";
    }).join("");
    barra.appendChild(extra);
    barra.classList.add("bukprod-nb-pronto");
  }

  /* A barra de cima: ícones próprios nas promessas e, à direita, «Apoio
     especializado» (o WhatsApp da loja, o mesmo do rodapé) e «Horário da
     loja» (a página que já existe). O ícone de cada promessa sai do texto,
     para continuar certo se mudarem a ordem no editor de temas. */
  var ICONES_BARRA = [
    [/portes|envio|entrega/i, '<path d="M1.5 5.5h12v10h-12z"/><path d="M13.5 9h4l3 3.2v3.3h-7"/><circle cx="5.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>'],
    [/aluguer|venda|garantia/i, '<path d="M12 2.5 4 5.5v6c0 5 3.4 8.6 8 10 4.6-1.4 8-5 8-10v-6z"/><path d="m8.5 12 2.5 2.5 4.5-5"/>'],
    [/loja|levantamento/i, '<path d="M3 9.5 12 3l9 6.5"/><path d="M5 9v11h14V9"/><path d="M9.5 20v-6h5v6"/>'],
  ];
  var APOIO = '<path d="M4 14v-2a8 8 0 0 1 16 0v2"/><rect x="2.5" y="13.5" width="4" height="6" rx="1.5"/><rect x="17.5" y="13.5" width="4" height="6" rx="1.5"/>';

  function svgBarra(d) {
    return '<svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + d + "</svg>";
  }

  function barraDeCima() {
    if (window.matchMedia && !window.matchMedia("(min-width: 1001px)").matches) return;
    var promessas = document.querySelectorAll("#nav-top > ul.l4us > li");
    for (var i = 0; i < promessas.length; i++) {
      var li = promessas[i];
      if (li.classList.contains("bukprod-bt")) continue;
      var txt = li.textContent || "";
      var ic = null;
      for (var k = 0; k < ICONES_BARRA.length; k++) if (ICONES_BARRA[k][0].test(txt)) { ic = ICONES_BARRA[k][1]; break; }
      if (!ic) continue;
      var alvo = li.querySelector(":scope > span") || li;
      alvo.insertAdjacentHTML("afterbegin", '<span class="bukprod-bt__ic">' + svgBarra(ic) + "</span>");
      li.classList.add("bukprod-bt");
    }
    var dir = document.querySelector("#nav-top ul.nav-top");
    if (!dir || dir.querySelector(".bukprod-bt-extra")) return;
    var tel = dir.querySelector('a[href^="tel:"]');
    var liTel = tel ? tel.closest("li") : null;
    var apoio = document.createElement("li");
    apoio.className = "bukprod-bt-extra";
    apoio.innerHTML = '<a href="https://wa.me/351965532077" target="_blank" rel="noopener">' + svgBarra(APOIO) +
      "<span>Apoio especializado</span></a>";
    dir.insertBefore(apoio, liTel || dir.firstChild);
    var sep = document.createElement("li");
    sep.className = "bukprod-bt-sep";
    sep.setAttribute("aria-hidden", "true");
    var horario = document.createElement("li");
    horario.className = "bukprod-bt-extra";
    horario.innerHTML = '<a href="/pages/horario-de-funcionamento">Horário de Funcionamento</a>';
    var depois = liTel ? liTel.nextSibling : null;
    dir.insertBefore(sep, depois);
    dir.insertBefore(horario, depois);
  }

  function arrancarCabecalho() {
    cabecalhoArrumado();
    barraDeCima();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arrancarCabecalho);
  } else {
    arrancarCabecalho();
  }
})();
